// extracted by css-extract-rspack-plugin
export default {"caption":"Caption_caption__6gDrK","caption--sm":"Caption_caption--sm__+T4ka","caption--up-sm":"Caption_caption--up-sm__BGPRO"};